/* eslint-disable jsx-a11y/alt-text */
import React, {useEffect, useState} from 'react'
import {Link} from "gatsby";
import BrakeInString from './BrakesInString'
import Section from "./Section";
import Title from "./Title";
import AnchoredPageNavItems from "./AnchoredPageNavItems";
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import Newsroom from './Newsroom'

const AnchoredPageComponent = ({nosqlData = null, pageTitle = null, newsroomData = null}) => {
  const {anchoredPage} = nosqlData;
  const columns = (nosqlData.columns) ? nosqlData.columns : 6;
  const title = pageTitle ? pageTitle : '';

  const [pathname, setPathname] = useState('');
  const [runCodeImages, setRunCodeImages] = useState(false);

  useEffect(() => {
    if(!runCodeImages) {
      let images = document.querySelectorAll('.nosql__inner-item-content--no-image .nosql__inner-item-text img');

      images.forEach(function (item) {
        let title = item.hasAttribute('title') ? item.getAttribute('title') : '';
        let src = item.hasAttribute('src') ? item.getAttribute('src') : '';
        let currentImage = document.querySelector('img[title="'+title+'"]');
        let div = document.createElement('div');

        div.innerHTML = title;
        div.classList.add('blog-post__image-desc');

        currentImage.after(div);

        if(src) {
          let wrapper = document.createElement('a');
          wrapper.setAttribute('href', src);
          wrapper.setAttribute('target', '_blank');
          wrapper.setAttribute('rel', 'noreferrer');
          wrapper.appendChild(item.cloneNode(true));
          item.parentNode.replaceChild(wrapper, item);
        }
      });

      setRunCodeImages(true);
    }

    setTimeout(function(){
      setPathname(window.location.pathname);},250);
  }, [pathname,runCodeImages]);

  return (
    <div className="page page-nosql nosql">
      <Section align="center" bg="gray">
        {title && (
            <h1><BrakeInString text={title} /></h1>
        )}

        <AnchoredPageNavItems items={anchoredPage.iconList} cols={columns}/>
      </Section>

      {anchoredPage.textList && anchoredPage.textList.length > 0 && (
        <div className="nosql__inner">
          {anchoredPage.textList.map( (item, index) => {
            const itemWidth = item.imageWidth ? item.imageWidth + 'px' : 'auto';
            const itemHeight = item.imageHeight ? item.imageHeight + 'px' : 'auto';

            return (
              <div id={item.slug} className="nosql__inner-item" key={index}>
                <Section align="center" >
                  {item.heading && (
                      <h2><BrakeInString text={item.heading} /></h2>
                  )}
                  {item.subheading && (
                      <h3><BrakeInString text={item.subheading} /></h3>
                  )}

                  <div className={item.image ? 'nosql__inner-item-content':'nosql__inner-item-content--no-image'} >
                    <div className={`nosql__inner-item-image ${item.showShadow === true ? 'nosql__inner-item-image--shadow' : ''} ${item.setSmallImage && item.setSmallImage === true ? 'nosql__inner-item-image--small' : ''}`}>
                      {item.image && !item.url && (
                          <a href={item.image} target="_blank" rel="noreferrer">
                            <img
                                src={item.image}
                                alt={item.imageAlt}
                                className={``}
                                style={{maxWidth: `${itemWidth}`, maxHeight: `${itemHeight}`}}
                            />
                          </a>
                      )}

                      {item.image && item.url && (
                          <a href={item.url} rel="noreferrer">
                            <img
                                src={item.image}
                                alt={item.imageAlt}
                                className={``}
                                style={{maxWidth: `${itemWidth}`, maxHeight: `${itemHeight}`}}
                            />
                          </a>
                      )}

                      {item.imageTitle && (
                          <div className="blog-post__image-desc">
                            {item.imageTitle}
                          </div>
                      )}

                    </div>
                    <div className="nosql__inner-item-text">
                      {item.title && (
                          <Title size="sm" level="3"><BrakeInString text={item.title} /></Title>
                      )}

                      {item.text && (
                          <div>
                            <ReactMarkdown skipHtml remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{item.text}</ReactMarkdown>
                          </div>
                      )}

                      {item.url && item.urlName && (
                          <Link to={item.url || ''}>
                            {item.urlName}
                          </Link>
                      )}


                      {item.additionalTexts && (
                        <>
                          {item.additionalTexts.map( (addItem, addIndex) => {
                            const addItemWidth = addItem.imageWidth ? addItem.imageWidth + 'px' : 'auto';
                            const addItemHeight = addItem.imageHeight ? addItem.imageHeight + 'px' : 'auto';

                            return (
                              <React.Fragment key={addIndex}>
                                {addItem.title && (
                                    <Title size="sm" level="3"><BrakeInString text={addItem.title} /></Title>
                                )}

                                {addItem.image && (
                                  <>
                                    <div className="nosql__inner-add-item-image">
                                      <img
                                          src={addItem.image}
                                          alt={addItem.imageAlt}
                                          style={{maxWidth: `${addItemWidth}`, maxHeight: `${addItemHeight}`}}
                                      />
                                    </div>
                                    {addItem.imageTitle && (
                                        <div className="blog-post__image-desc">
                                          {addItem.imageTitle}
                                        </div>
                                    )}
                                  </>
                                )}

                                {addItem.text && (
                                    <div className="nosql__inner-add-item-text">
                                      <ReactMarkdown skipHtml remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{addItem.text}</ReactMarkdown>
                                    </div>
                                )}

                              </React.Fragment>
                            )
                          })}
                        </>
                      )}
                    </div>
                  </div>

                  {item.itemList && (
                    <>
                      {item.itemList.map( (addItem, addIndex) => {
                        const addItemWidth = addItem.imageWidth ? addItem.imageWidth + 'px' : 'auto';
                        const addItemHeight = addItem.imageHeight ? addItem.imageHeight + 'px' : 'auto';

                        return (
                          <div className={addItem.image ? 'nosql__inner-item-content':'nosql__inner-item-content--no-image'} key={addIndex}>
                            <div className={`nosql__inner-item-image ${addItem.showShadow === true ? 'nosql__inner-item-image--shadow' : ''} ${addItem.setSmallImage && addItem.setSmallImage === true ? 'nosql__inner-item-image--small' : ''}`}>

                              {addItem.image && (
                                  <a href={addItem.image} target="_blank" rel="noreferrer">
                                    <img
                                        src={addItem.image}
                                        alt={addItem.imageAlt}
                                        style={{maxWidth: `${addItemWidth}`, maxHeight: `${addItemHeight}`}}
                                        className={``}/>
                                  </a>
                              )}

                              {addItem.imageTitle && (
                                  <div className="blog-post__image-desc">
                                    {addItem.imageTitle}
                                  </div>
                              )}
                            </div>
                            <div className="nosql__inner-item-text">
                              {addItem.title && (
                                  <Title size="sm" level="3"><BrakeInString text={addItem.title} /></Title>
                              )}
                              {addItem.text && (
                                  <div>
                                    <ReactMarkdown skipHtml remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{addItem.text}</ReactMarkdown>
                                  </div>
                              )}
                              {addItem.url && addItem.urlName && (
                                  <Link to={addItem.url || ''}>
                                    {addItem.urlName}
                                  </Link>
                              )}

                              {addItem.additionalTexts && (
                                <>
                                  {addItem.additionalTexts.map( (addInnerItem, addInnerIndex) => {
                                    const addInnerItemWidth = addInnerItem.imageWidth ? addInnerItem.imageWidth + 'px' : 'auto';
                                    const addInnerItemHeight = addInnerItem.imageHeight ? addInnerItem.imageHeight + 'px' : 'auto';

                                    return (
                                      <React.Fragment key={addInnerIndex}>
                                        <Title size="sm" level="3"><BrakeInString text={addInnerItem.title} /></Title>
                                        {addInnerItem.image && (
                                          <div className="nosql__inner-add-item-image">
                                            <img
                                              key={addInnerItem.imageAlt}
                                              style={{maxWidth: `${addInnerItemWidth}`, maxHeight: `${addInnerItemHeight}`}}
                                              src={addInnerItem.image}/>
                                          </div>
                                        )}
                                        {addInnerItem.text && (
                                            <div className="nosql__inner-add-item-text">
                                              <ReactMarkdown skipHtml remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{addInnerItem.text}</ReactMarkdown>
                                            </div>
                                        )}
                                      </React.Fragment>
                                    )
                                  })}
                                </>
                              )}
                            </div>
                          </div>
                        )
                      })}
                    </>
                  )}
                </Section>
              </div>
            )
          })}
        </div>
      )}

      {pathname && pathname.includes('/resources') && newsroomData && newsroomData.length > 0 && (
          <section className="section">
            <div className="container section__container">
              <Title level="2" size="l">What's new</Title>
              <Newsroom newsroomData={newsroomData} />
            </div>
          </section>
      )}

    </div>
  );
};

export default AnchoredPageComponent;

